// A sign-in counts as verified once the emailed code (or a trusted device) was
// accepted for it. Rules require this for writes and inbox reads.

const deviceTokenKey = (uid) => `otpDeviceToken:${uid}`

export function isVerifiedClaims(claims) {
  return Array.isArray(claims?.otpSessions) && claims.otpSessions.includes(claims.auth_time)
}

export async function isVerifiedSession(user) {
  const { claims } = await user.getIdTokenResult()
  return isVerifiedClaims(claims)
}

export function getDeviceToken(uid) {
  return localStorage.getItem(deviceTokenKey(uid))
}

export function saveDeviceToken(uid, token) {
  localStorage.setItem(deviceTokenKey(uid), token)
}

export function forgetDeviceToken(uid) {
  localStorage.removeItem(deviceTokenKey(uid))
}

// Asks verifyLoginSession to accept this sign-in, then refreshes the token so the rules see it.
export async function verifyLoginSession(user, body) {
  const idToken = await user.getIdToken()
  const resp = await fetch(process.env.VUE_APP_VERIFY_LOGIN_SESSION_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${idToken}`
    },
    body: JSON.stringify(body)
  })
  if (!resp.ok) return false
  await user.getIdToken(true)
  return true
}

// Re-entering the password starts a new sign-in; carry the verified state over to it.
export async function keepSessionVerified(auth, step) {
  const previousIdToken = await auth.currentUser.getIdToken()
  const result = await step()
  await verifyLoginSession(auth.currentUser, { via: 'reauth', previousIdToken })
  return result
}
